








// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBasePiscine from '@/components/administration/piscine/edit/EditBasePiscine.vue'
import EditBasePage from '@/components/shared/EditBasePage.vue'
import { AloPiscine,getDefaultAloPiscine } from '@/models/alo/AloPiscine'

@Component({
  name: 'EditPage',     
  components:{EditBasePiscine,EditBasePage}
})
export default class EditPage extends Vue {
      
  private piscine:AloPiscine = getDefaultAloPiscine()

  get configuration(){
    return this.$store.myGetters.configuration
  }

  private get editorConfig(){
    return {...this.configuration.editorDefaultConfig,height:350}
  }  

  edit(item:AloPiscine) {            
    this.piscine = (this.$refs.baseEdit as EditBasePiscine).edit(item)    
  }        
}
